module.exports = __webpack_public_path__ + "static/media/md-magnet.a4e31444.svg";